import { useState, useEffect } from 'react';
import { DropdownOptionProps } from 'src/components/CookbookSelectWrapper/CookbookSelectWrapper';
import { filterOptions } from 'src/components/CookbookClientSelectSearchWrapper/useClientSelectSearch.utils';

export interface UseFilteredOptions {
  displayedOptions: DropdownOptionProps[];
  onSearchHandle: (searchValue: string) => void;
  restoreOptions: () => void;
}

export function useClientSelectSearch({
  options = [],
}: {
  options: DropdownOptionProps[];
}): UseFilteredOptions {
  const [displayedOptions, setDisplayedOptions] =
    useState<DropdownOptionProps[]>(options);

  useEffect(() => {
    setDisplayedOptions(options);
  }, [options]);

  const onSearchHandle = (searchValue: string): void => {
    const filteredOptions = searchValue
      ? filterOptions(options, searchValue)
      : options;

    setDisplayedOptions(filteredOptions);
  };

  const restoreOptions = (): void => {
    setDisplayedOptions(options);
  };

  return {
    displayedOptions,
    onSearchHandle,
    restoreOptions,
  };
}
